<div mat-dialog-content>
    <div class="image-wrapper">
        <img [src]="image.url" [alt]="image.name" />
    </div>
</div>
